<template>
  <div class="flex-item iq-card" style="width: 30%;">
    <div class="iq-card-header pt-2">
      <div class="iq-card-title">
        <h5 class="card-title">Fuel Consumption Summary</h5>
      </div>
    </div>
    <div class="iq-card-body flex-container">
      <table class="table flex-item">
        <thead class="thead-light">
          <th>Fuel Summary</th>
          <th>Value</th>
          <th>Unit</th>
        </thead>
        <tbody v-if="hasData">
          <template v-if="channels.measured.length">
            <tr class="group-header-row">
              <td colspan="3"><b>MEASURED &mdash; FLOWMETER</b></td>
            </tr>
            <tr v-for="channel in channels.measured" :key="channel.name">
              <td class="channel-cell">{{ channelLabel(channel.name) }}</td>
              <td>{{ liters(channel.value) }}</td>
              <td>Liter</td>
            </tr>
            <tr v-if="channels.measured.length > 1">
              <td class="channel-cell"><b>Subtotal</b></td>
              <td><b>{{ liters(channels.measuredTotal) }}</b></td>
              <td>Liter</td>
            </tr>
          </template>

          <template v-if="channels.calculated.length">
            <tr class="group-header-row">
              <td colspan="3"><b>ESTIMATED &mdash; CONSTANTA</b></td>
            </tr>
            <tr v-for="channel in channels.calculated" :key="channel.name">
              <td class="channel-cell">{{ channelLabel(channel.name) }}</td>
              <td>{{ liters(channel.value) }}</td>
              <td>Liter</td>
            </tr>
          </template>

          <tr class="total-row">
            <td><b>Total</b></td>
            <td><b>{{ liters(channels.total) }}</b></td>
            <td><b>Liter</b></td>
          </tr>
          <tr v-if="channels.estimatePct > 0">
            <td colspan="3" class="estimate-note">
              Includes {{ formatNum(channels.estimatePct, 1) }}% estimate
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="3" class="text-center">No data available</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { classifyFuelChannels, meRolePrefix } from '@/util/fuel-channels';
import { prettyLabel } from '@/util/vesselDetail';
import { formatNum } from '@/util/number';

export default {
  name: 'FuelConsumptionSummaryCard',
  props: {
    // deviceStatus.flowmeterGroups
    groups: {
      type: Array,
      default: () => [],
    },
    // rawSummary.flowmeter.summary - angka mentah, bukan string tampilan
    fmSummary: {
      type: Object,
      default: () => ({}),
    },
    aeCons: {
      type: [String, Number],
      default: null,
    },
    aeHidden: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    channels() {
      return classifyFuelChannels({
        groups: this.groups,
        fmSummary: this.fmSummary,
        aeCons: this.aeCons,
        aeHidden: this.aeHidden,
      });
    },
    hasData() {
      return this.channels.measured.length > 0 || this.channels.calculated.length > 0;
    },
  },
  methods: {
    formatNum,
    liters(value) {
      return formatNum(value, 2);
    },
    channelLabel(name) {
      return `${meRolePrefix(name)} ${prettyLabel(name)}`.trim();
    },
  },
};
</script>

<style scoped>
.group-header-row td {
  background: #f5f7fb;
  padding-top: 10px;
}

.channel-cell {
  padding-left: 24px;
}

.total-row td {
  border-top: 2px solid #dee2e6;
}

.estimate-note {
  color: #6b7280;
  font-size: 12px;
  padding-top: 0;
}
</style>
